// ViewTab.tsx
import React, { useEffect, useState } from 'react';
import {
    Button,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    UncontrolledDropdown
} from 'reactstrap';
import BreadCrumb from '../BreadCrumb';
import { withTranslation } from 'react-i18next';
import {
    getViewFromLocal,
    storeViewToLocal,
    viewCreateRequest,
    viewDelete,
    viewsMetadataGetRequest,
    viewUpdateRequest
} from 'store/views/action';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { ApplicationState } from 'store';
import { ToastContainer } from 'react-toastify';
import AddView from './innerComponent/AddView';
import DeleteViewModal from './innerComponent/DeleteViewModal';
import ListingLoader from 'Components/Common/FormBuilder/ListingLoader';
import { getViewList, isJson } from 'utils';
import ImportModal from './innerComponent/ImportDataModal';
import ViewAll from './innerComponent/ViewAllView';
import UpdateView from './innerComponent/UpdateView';
import { useNavigate } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { isEqual } from 'lodash';
import { BaseButton, BaseNavLink } from 'Components/Common/Base';
import { withPermission } from 'Components/HOCs/withPermission';
import {
    DragDropContext,
    Droppable,
    Draggable,
    DropResult,
  } from 'react-beautiful-dnd';
import ArrangeViews from './innerComponent/ArrangeViews';
import { bulkUpdateRequest } from 'store/bulk/action';
  

const CreateButton = withPermission(BaseButton, {
    module: (props) => props.model,
    action: 'create',
    featureKey: (props) => props.model,
    tooltipId: 'createBtn-tooltip'
});

const DedupeButton = withPermission(BaseButton, {
    module: (props) => props.model,
    action: 'manage duplicates',
    featureKey: (props) => props.model,
    tooltipId: 'dedupeBtn-tooltip'
});

const ImportButton = withPermission(BaseButton, {
    module: (props) => props.model,
    action: 'import',
    featureKey: (props) => props.model,
    tooltipId: 'importBtn-tooltip'
});

const AddViewButton = withPermission(BaseButton, {
    module: 'views',
    parent_model: (props) => props.model,
    action: 'create',
    featureKey: 'views',
    tooltipId: 'viewBtn-tooltip'
});

const AllViewsNavLink = withPermission(BaseNavLink, {
    module: 'views',
    parent_model: (props) => props.model,
    action: 'views',
    featureKey: 'views',
    tooltipId: 'allViewsNavLink-tooltip'
});

const ViewTab: React.FC<any> = (props: any) => {
    const navigate = useNavigate();
    const dispatch: ThunkDispatch<any, null, any> = useDispatch();
    const { metadata, model, title, isBulkUpload, downloadBulkTemplate, child, isSubAgent, isDuplicatesBtn } = props;

    const viewslist: any = useSelector((state: ApplicationState) => state.views.list?.[model]);
    const loading: any = useSelector((state: ApplicationState) => state.views.loading);
    const authLoading = useSelector((state: ApplicationState) => state.auth.meloading);
    // Legacy permission check removed in favor of HOC-based checks
    const userProfile = useSelector((state: ApplicationState) => state.auth.userProfile);
    const storeView = useSelector((state: ApplicationState) => state.views.storeView);
    const viewsFields = useSelector((state: ApplicationState) => state.views.metaDataFields);
    const bulkloading = useSelector((state: ApplicationState) => state.bulk.loading);

    // State Variables
    const [activeTab, setActiveTab] = useState<any>('zilter_default');
    const [updatedViewOrder, setupdatedViewOrder] = useState<any>([])
    const [views, setViews] = useState<any>([]);
    const [isAddviewopen, setAddviewOpen] = useState<boolean>(false);
    const [isCreateModal, setCreateOpen] = useState<boolean>(false);
    const [viewname, setViewname] = useState<string>('');
    const [defaultFields, setFields] = useState<any>([]);
    const [record, setRecord] = useState<any>([]);
    const [isDeleteOpen, setisDeleteOpen] = useState<boolean>(false);
    const [viewId, setviewId] = useState<string>('zilter_default');
    const [triggerApi, setTriggerApi] = useState<boolean>(false);
    const [list, setList] = useState<any>([]);
    const [isViewAll, setIsViewAll] = useState<boolean>(false);
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const [isImportOpen, setIsImportOpen] = useState<boolean>(false);
    const [isArrange, setIsArrange] = useState<boolean>(false);

    // This helper ensures that we update our list when viewslist changes.
    const execute = () => !isEqual(viewslist, list);

    // Update list data from the Redux store.
    useEffect(() => {
        const parsedData: any =[];
        viewslist && viewslist.length
            && viewslist.map((item: any) => {
                const valuesJson = item?.valuesJson || item;
                const values = { ...item, ...valuesJson };
                if(values?.location === 'listing') {
                    parsedData.push(values)
                }
            });
        const data = parsedData.length ? parsedData : [];
        setList(viewslist);
        let filteredViews = data.filter((item: any) => handlePrivateViews(item))
        const sortedViews = [...filteredViews].sort((a, b) => a.sequence - b.sequence);
        setViews(sortedViews);
    }, [execute(), viewslist]);

    // Set active view from local storage, or default.
    useEffect(() => {
        if (viewslist && viewslist.length && storeView?.[model]) {
            let isExist = viewslist.find((item: any) => item?.id === storeView?.[model])
            if(isExist){
                setviewId(storeView[model]);
                setActiveTab(storeView[model]);
            }
            else {
                setviewId('zilter_default');
                setActiveTab('zilter_default');
            }
        } else {
            setviewId('zilter_default');
            setActiveTab('zilter_default');
        }
    }, [storeView?.[model], viewslist]);

    // Fetch Views metadata and local view data
    useEffect(() => {
        dispatch(getViewFromLocal());
        dispatch(viewsMetadataGetRequest({ pageSize: 500 }));
    }, [dispatch]);

    // Fetch Views List with a timer.
    useEffect(() => {
        getViewList(dispatch, model, "listing", true)
    }, [triggerApi, dispatch, model]);

    useEffect(() => {
        const newFields: any = [];
        if (metadata && metadata.length) {
            metadata.forEach((field: any) => {
                const item = field?.valuesJson && isJson(field.valuesJson) ? JSON.parse(field.valuesJson) : {};
                newFields.push({ id: field.id, extras: { key: item.key, show: item.tablecolumn } });
            });
        }
        setFields(newFields);
    }, [metadata]);

    useEffect(() => {
        setviewId(activeTab);
    }, [activeTab]);

    // Changing view tab method  
    const toggleTab = async (tab: any) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            await dispatch(storeViewToLocal({ [model]: tab }));
            dispatch(getViewFromLocal());
        }
    };

    // Filtering private views.
    const handlePrivateViews = (item: any) => {
        if (item?.isprivate === "true" || item?.isprivate === true) {
            const createdBy = item?.createdBy?.id || item?.createdBy;
            return createdBy === userProfile?.id;
        }
        return true;
    };

    // Create view method.
    const onCreate = (formValues: any) => {
        const data = {
            ...formValues,
            primary: "true",
            model: model,
            location: "listing",
            fields: JSON.stringify(defaultFields),
            filters: JSON.stringify([]),
        };
        const handleSuccess = (body: any) => {
            setViewname("");
            setTriggerApi((prev: boolean) => !prev);
            setAddviewOpen(false);
            toggleTab(`${body?.id}`);
        };
        const handleFailure = () => { };
        dispatch(viewCreateRequest(data, model, handleSuccess, handleFailure));
    };

    // Update view method.
    const onUpdate = (formValue: any) => {
        const handleSuccess = () => {
            setViewname("");
            setTriggerApi((prev: boolean) => !prev);
            setIsEditOpen(false);
        };
        const handleFailure = () => { };
        dispatch(viewUpdateRequest(record.id, formValue, model, handleSuccess, handleFailure));
    };

    // Delete view method.
    const onDelete = (id: any) => {
        const handleSuccess = () => {
            setTriggerApi((prev: boolean) => !prev);
            setisDeleteOpen(false);
            if(storeView[model] === id){
                toggleTab('zilter_default');
            }
        };
        const handleFailure = () => { };
        dispatch(viewDelete(id, model, handleSuccess, handleFailure));
    };

    return (
        <div>
            <ToastContainer closeButton={true} />
            {!authLoading ? (
                // Removed legacy permission handling in favor of using our HOC-wrapped buttons.
                <>
                    <AddView
                        onCreate={onCreate}
                        viewname={viewname}
                        setViewname={setViewname}
                        props={props}
                        show={isAddviewopen}
                        onCloseClick={() => setAddviewOpen(false)}
                        setTriggerApi={setTriggerApi}
                    />
                    {isAddviewopen && (
                        <AddView
                            show={isAddviewopen}
                            onCloseClick={() => setAddviewOpen(false)}
                            dataFields={viewsFields}
                            props={props}
                            onCreate={onCreate}
                        />
                    )}
                    <UpdateView
                        onUpdate={onUpdate}
                        props={props}
                        data={record}
                        show={isEditOpen}
                        onCloseClick={() => setIsEditOpen(false)}
                        dataFields={viewsFields}
                    />
                    <ViewAll
                        props={props}
                        show={isViewAll}
                        onCloseClick={() => setIsViewAll(false)}
                        viewlist={views}
                        setisDeleteOpen={setisDeleteOpen}
                        setIsEditOpen={setIsEditOpen}
                        setRecord={setRecord}
                        setViewname={setViewname}
                        viewId={activeTab}
                        model={model}
                        toggleTab={toggleTab}
                        loading={loading}
                        setupdatedViewOrder={setupdatedViewOrder}
                        updatedViewOrder={updatedViewOrder}
                    />
                    <ArrangeViews
                        props={props}
                        show={isArrange}
                        onCloseClick={() => setIsArrange(false)}
                        viewlist={views}
                        setisDeleteOpen={setisDeleteOpen}
                        setIsEditOpen={setIsEditOpen}
                        setRecord={setRecord}
                        setViewname={setViewname}
                        viewId={activeTab}
                        model={model}
                        toggleTab={toggleTab}
                        loading={loading || bulkloading}
                        setupdatedViewOrder={setupdatedViewOrder}
                        updatedViewOrder={updatedViewOrder}
                        setViews={setViews}
                    />
                    <DeleteViewModal
                        show={isDeleteOpen}
                        onCloseClick={() => setisDeleteOpen(false)}
                        props={props}
                        record={record}
                        onDelete={onDelete}
                    />
                    {isImportOpen && (
                        <ImportModal
                            props={props}
                            show={isImportOpen}
                            onCloseClick={() => setIsImportOpen(false)}
                            model={model}
                            downloadBulkTemplate={downloadBulkTemplate}
                        />
                    )}
                    {/* Header: Breadcrumbs and Action Buttons */}
                    {!child ? (
                        <Row className="hstack justify-content-between">
                            {model && model !== "sources" ? (
                                <Col>
                                    <BreadCrumb title={title} pageTitle={title} icon="ri-list-check" />
                                </Col>
                            ) : null}

                            <Col className="hstack justify-content-end gap-2">
                                <div className="hstack gap-2">
                                    {isDuplicatesBtn && <DedupeButton onClick={() => navigate(`/duplicates?model=${model}`)} color="primary" size="sm" model={model}>
                                        <i className="ri-user-add-fill label-icon align-middle fs-16 me-2" />
                                        {props.t("student.listing.action_button.deduplicate")}
                                    </DedupeButton>}
                                    {isBulkUpload && (
                                        <ImportButton onClick={() => navigate(`/import?model=${model}`)} color="primary" size="sm" model={model}>
                                            <i className="ri-user-add-fill label-icon align-middle fs-16 me-2" />
                                            {props.t("student.listing.action_button.bulk_entry")}
                                        </ImportButton>
                                    )}
                                    {model !== 'applications' && (
                                        <CreateButton onClick={() => setCreateOpen(true)} color="primary" size="sm" model={model}>
                                            <i className="ri-user-add-fill label-icon align-middle fs-16 me-2" />
                                            {props.t("student.listing.action_button.create_entry")}
                                        </CreateButton>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    ) : null}
                    <Row>
                        <Col xl={12} md={12} sm={12}>
                            <div className="hstack justify-content-between">
                                <div className="hstack justify-content-start">
                                    <Nav className="nav-tabs-custom border-bottom-0 flex-grow-1 d-flex flex-wrap" role="tablist">
                                        <NavItem
                                            className={
                                                activeTab === 'zilter_default'
                                                    ? 'hstack justify-content-between border border-bottom-0 border-primary border-end-0'
                                                    : 'hstack justify-content-between border border-primary border-end-0'
                                            }
                                        >
                                            <NavLink
                                                className={'fw-medium fs-14 p-1 px-3  py-2'}
                                                onClick={() => toggleTab('zilter_default')}
                                                href="#"
                                            >
                                                Default
                                            </NavLink>
                                        </NavItem>
                                        <div
                                            className="d-flex flex-wrap"
                                        >
                                            {views.slice(0, 5).map((item: any, index: number) => (
                                            <div key={item.id}>
                                                <div>
                                                    <NavItem
                                                    className={
                                                        activeTab === item.id
                                                            ? 'h-100 hstack justify-content-between border border-bottom-0 border-primary border-end-0'
                                                            : 'h-100 hstack justify-content-between border border-primary border-end-0'
                                                    }
                                                    >
                                                    <NavLink
                                                        className={'fw-medium fs-14 p-1 px-3  py-2'}
                                                        onClick={() => toggleTab(item.id)}
                                                        href="#"
                                                    >
                                                        <div
                                                        className="text-truncate"
                                                        style={{ maxWidth: 85 }}
                                                        title={item.name}
                                                        >
                                                        {item.name}
                                                        </div>
                                                    </NavLink>
                                                    {item.name.toLowerCase() !== 'zilter_default' && (
                                                        <span
                                                        onClick={() => {
                                                            setisDeleteOpen(true);
                                                            setRecord(item);
                                                        }}
                                                        className="cursor-pointer"
                                                        >
                                                        <i className="ri-close-line label-icon align-middle fs-13 me-2" />
                                                        </span>
                                                    )}
                                                    </NavItem>
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                        {views.length > 5 && (
                                            <NavItem className="hstack">
                                                <UncontrolledDropdown>
                                                <DropdownToggle
                                                    tag="button"
                                                    className="btn btn-ghost-primary btn-sm dropdown p-0"
                                                >
                                                    <Button color="primary" className="btn-icon border border-primary rounded-0">
                                                    <i className="ri-more-2-line label-icon align-middle fs-16 me-2"></i>
                                                    </Button>
                                                </DropdownToggle>

                                                <DropdownMenu className="dropdown-menu-end">
                                                    <SimpleBar style={{ maxHeight: 200 }}>
                                                    {views.map((item: any, index:any) => {
                                                        if (index < 5) return null;
                                                        return (
                                                        <div key={item.id}>
                                                            <div>
                                                                <NavItem
                                                                className={`hstack justify-content-start ${
                                                                    activeTab === item.id
                                                                    ? 'bg-primary text-light'
                                                                    : 'border-primary'
                                                                }`}
                                                                >
                                                                <NavLink
                                                                    className="fw-medium fs-14 p-1 py-2 hstack align-items-center"
                                                                    onClick={() => toggleTab(item.id)}
                                                                    href="#"
                                                                >
                                                                    <span
                                                                    className={`${
                                                                        activeTab === item.id
                                                                        ? 'text-light ms-1'
                                                                        : 'text-primary ms-1'
                                                                    }`}
                                                                    >
                                                                    <div
                                                                        className="text-truncate"
                                                                        style={{
                                                                        maxWidth: 100,
                                                                        overflow: 'hidden',
                                                                        maxHeight: 50
                                                                        }}
                                                                        title={item.name}
                                                                    >
                                                                        {item.name}
                                                                    </div>
                                                                    </span>
                                                                </NavLink>
                                                                </NavItem>
                                                            </div>
                                                        
                                                        </div>
                                                        );
                                                    })}
                                                    </SimpleBar>
                                                </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </NavItem>
                                        )}
                                    </Nav>
                                    <div>
                                        <AddViewButton onClick={() => setAddviewOpen(true)} color="primary" className="border-0 rounded-0" model={model}>
                                            <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                                            {props.t("student.listing.breadcrumb.add_view")}
                                        </AddViewButton>
                                    </div>
                                </div>
                                <div  className='d-flex gap-1'>
                                    {views.length > 0 && <div>
                                        <span className="cursor-pointer">
                                            <UncontrolledDropdown>
                                                <DropdownToggle
                                                    href="#"
                                                    className="btn btn-ghost-primary btn-sm dropdown"
                                                    tag="button"
                                                    title="View Settings"
                                                >
                                                    <i className="ri-settings-2-fill label-icon align-middle fs-16 me-2 text-primary"></i>
                                                </DropdownToggle>
                                                <DropdownMenu className="dropdown-menu-end">
                                                    <DropdownItem className="dropdown-item" onClick={() => setIsViewAll(true)} >
                                                        <span className="fs-12 fw-normal" >
                                                        {props.t(`student.details.about.all_views`)}
                                                        </span>
                                                    </DropdownItem>
                                                    <DropdownItem className="dropdown-item" onClick={() => {setIsArrange(true)}}>
                                                        <span className="fs-12">
                                                        {props.t(`student.listing.action_button.arrange_view`)}
                                                        </span>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </span>
                                    </div>}
                                </div>
                            </div>
                        </Col>
                        <Col xl={12} md={12} sm={12}>
                            <TabContent activeTab={activeTab}>
                                {viewId === 'zilter_default' && (
                                    <TabPane tabId="zilter_default" key="zilter_default">
                                        <props.component
                                            {...{
                                                ...props.componentProps,
                                                isCreateModal,
                                                setCreateOpen,
                                                isSubAgent
                                            }}
                                        />
                                    </TabPane>
                                )}
                                {views.length > 0 &&
                                    views.map((item: any, index: number) => {
                                        if (`${item.id}` === viewId)
                                            return (
                                                <TabPane tabId={`${item.id}`} key={index}>
                                                    <props.component
                                                        {...{
                                                            ...props.componentProps,
                                                            isCreateModal,
                                                            setCreateOpen,
                                                            viewId,
                                                            isSubAgent
                                                        }}
                                                    />
                                                </TabPane>
                                            );
                                    })}
                            </TabContent>
                        </Col>
                    </Row>
                </>
            ) : (
                <ListingLoader
                    title={title}
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light text-muted"
                    thClass="border-bottom-1 table-soft-primary"
                />
            )}
        </div>
    );
};

export default withTranslation()(ViewTab);
